@if (filter.optionsWithCurrentMatches?.length) {
<filter-expandable [toggleState]="isDefault"
                   [selectedOptionsQty]="selectedOptionsQty"
                   [selectedOptionsLabels]="filter.getSelectionLabel() + ''">
    <span class="s1"
          expandableTitle>{{filter.attribute.data?.label}}</span>


    <div expandableBody
         class="flex-column">
        @for (option of filter.optionsWithCurrentMatches; track option) {
        @switch (filter.attribute.data?.isSwatch) {
        @case(true) {
        <div class="m-t-2 w-12 flex flex-middle flex-justify-between"
             [class.m-t-5]="$first"
             [class.is-disabled]="filter.isUnavailble(option)">
            <div>
                <!-- swatch icon -->
                <swatch [option]="option"
                        style="width: 17px;"
                        class="inline-block va-m m-r-2" />
                <!-- label -->
                <button type="button"
                        class="p1 col-1 inline-block va-m"
                        (click)="filter.toggle(option)">{{option.label}}</button>
            </div>
            <checkbox class="p2">
                <span class="inline-block flex flex-middle m-r-2">
                    ({{filter.getCurrentMatchesCount(option)}})
                </span>
                <input type="checkbox"
                       class="cursor-pointer"
                       name="checkboxFilters"
                       [checked]="filter.isSelected(option)"
                       (change)="filter.toggle(option)" />
            </checkbox>
        </div>
        }
        @default {
        <div class="m-t-2 w-12 flex flex-middle flex-justify-between"
             [class.m-t-5]="$first"
             [class.is-disabled]="filter.isUnavailble(option)">
            <div>
                <button type="button"
                        class="p1 col-1 inline-block va-m"
                        (click)="filter.toggle(option)">{{option.label}}</button>
            </div>
            <checkbox class="p2">
                <span class="inline-block flex flex-middle m-r-2">
                    ({{filter.getCurrentMatchesCount(option)}})
                </span>
                <input type="checkbox"
                       class="cursor-pointer"
                       name="checkboxFilters"
                       [checked]="filter.isSelected(option)"
                       (change)="filter.toggle(option)" />
            </checkbox>
        </div>
        }
        }
        }
    </div>
</filter-expandable>
}